module.exports = __webpack_public_path__ + "static/media/addCategoryIllustration.4b0ad526.svg";